import {Pagination} from '@app/core/models/pagination.model';
import {Shift} from '@app/core/models/shift.model';
import {
	PERIOD_TYPE,
	VIEW_TYPE
} from '@app/modules/home/modules/schedule/components/planning-controls/planning-controls.component';
import * as moment from 'moment';
import {Moment} from 'moment';
import {Group} from '@app/core/models/group.model';
import {User} from '@app/core/models/user.model';
import {Availability} from '@app/core/models/availability.model';
import {SORTING_TYPE} from '@app/modules/home/modules/schedule/components/planning-header/planning-header.component';

export interface IScheduleState {
	isCreatingUpdatingDeletingShift: boolean;
	selectedShift: Shift | null | undefined;
	shifts: Shift[];
	availabilities: Availability[];
	users: User[];
	groups: Group[];
	selectedModel: Group | User;
	selectedDates: Moment[];
	selectedDate: Moment;
	pagination: Pagination;
	isLoading: boolean;
	isCopying: boolean;
	draggingShift: Shift | undefined;
	isShiftsLoading: boolean;
	selectedStartWeek: number;
	selectedYear: number;
	viewType: VIEW_TYPE;
	periodType: PERIOD_TYPE;
	sortingType: SORTING_TYPE;
	fetchedShift: Shift | null;
	availableUsers: User[];
	usersWhoBid: User[];
	scrollLeft: number;
	printing: boolean;
	userShifts: Shift[];

	departmentsIdsCalculated: { id: number }[];
	hasShiftChanges: boolean;
	lastShiftUpdated: Shift;
	lastShiftUpdating: Shift;

}

export const initialScheduleState: IScheduleState = {
	isCreatingUpdatingDeletingShift: false,
	selectedShift: undefined,
	shifts: [],
	availabilities: [],
	users: [],
	groups: [],
	selectedModel: undefined,
	pagination: undefined,
	isLoading: false,
	isCopying: false,
	draggingShift: undefined,
	isShiftsLoading: false,
	selectedStartWeek: moment().isoWeek(),
	selectedYear: moment().isoWeekYear(),
	selectedDates: [],
	selectedDate: undefined,
	viewType: localStorage.getItem('viewType') ? parseInt(localStorage.getItem('viewType')) : VIEW_TYPE.GROUP_VIEW,
	periodType: PERIOD_TYPE.ONE_WEEK,
	sortingType: localStorage.getItem('sortingType') ? parseInt(localStorage.getItem('sortingType')) : SORTING_TYPE.AZ,
	fetchedShift: null,
	availableUsers: [],
	usersWhoBid: [],
	scrollLeft: 0,
	printing: false,
	userShifts: [],
	departmentsIdsCalculated: [],
	hasShiftChanges: false,
	lastShiftUpdated: null,
	lastShiftUpdating: null,
};
